var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useStations } from '../../hooks';
import GoogleMaps from '../GoogleMaps';
var Map = function (_a) {
    var selectdStationId = _a.selectdStationId, onMarkerClick = _a.onMarkerClick, _b = _a.mapOptions, mapOptions = _b === void 0 ? {} : _b, center = _a.center, _c = _a.filter, filter = _c === void 0 ? function () { return true; } : _c, children = _a.children, rest = __rest(_a, ["selectdStationId", "onMarkerClick", "mapOptions", "center", "filter", "children"]);
    var stations = useStations();
    useEffect(function () {
        if (selectdStationId)
            onMarkerClick(selectdStationId);
    }, [selectdStationId]);
    var markers = useMemo(function () { return stations
        .filter(filter)
        .map(function (station) { return ({
        lat: station.lat,
        lng: station.lng,
        color: station.color,
        selected: selectdStationId === station.id,
        onClick: function () { return onMarkerClick(station.id); }
    }); }); }, [stations, selectdStationId, filter]);
    return (_jsx(GoogleMaps, __assign({}, rest, { className: "map-container", markers: markers, mapOptions: mapOptions, center: center }, { children: children }), void 0));
};
export default Map;
//# sourceMappingURL=Map.js.map